import React, { type ReactNode } from "react";

import { GenericTooltip } from "@components/tooltip-container";
import { type Filter } from "@features/overview-v2/components/tile/filter-pill";
import { type FloatingPosition } from "@mantine/core";

interface Props {
  children: ReactNode;
  filter: Filter;
  placement?: FloatingPosition;
}

export const Tooltip = ({ children, filter, placement }: Props) => {
  return (
    <GenericTooltip
      noInfoCircle
      mouseEnterDelay={0.3}
      placement={placement ?? "bottom"}
      content={
        <div className="text-xs min-w-[140px] -mr-3">
          <div className="text-xxs text-gray+2 mb-2.5 pr-3">
            {filter.breakdown} ({filter.values.length} of {filter.total})
          </div>
          <div className="max-h-[300px] overflow-y-auto pr-3 space-y-2">
            {filter.values.map((e) => (
              <div key={e} className="text-interstellar+2">
                {e}
              </div>
            ))}
          </div>
        </div>
      }
    >
      {children}
    </GenericTooltip>
  );
};
